module.exports = __webpack_public_path__ + "static/media/ic_loan_schedule.60172787.svg";